.badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 2px 8px;
  border: 1px solid;
  border-radius: var(--radius-pill);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.2px;
  white-space: nowrap;
}

.neutral {
  border-color: var(--line2);
  background: var(--surf2);
  color: var(--text2);
}
.success {
  border-color: color-mix(in srgb, var(--lime) 55%, transparent);
  background: color-mix(in srgb, var(--lime) 14%, transparent);
  color: var(--text-success);
}
.info {
  border-color: color-mix(in srgb, var(--aqua) 55%, transparent);
  background: color-mix(in srgb, var(--aqua) 14%, transparent);
  color: var(--text-info);
}
.warn {
  border-color: color-mix(in srgb, var(--amber) 55%, transparent);
  background: color-mix(in srgb, var(--amber) 14%, transparent);
  color: var(--text-warn);
}
.danger {
  border-color: color-mix(in srgb, var(--magenta) 55%, transparent);
  background: color-mix(in srgb, var(--magenta) 16%, transparent);
  color: var(--magenta);
}
.ai {
  border-color: color-mix(in srgb, var(--magenta) 50%, transparent);
  background: linear-gradient(
    135deg,
    color-mix(in srgb, var(--maroon) 30%, transparent),
    color-mix(in srgb, var(--magenta) 22%, transparent)
  );
  color: #fff;
}

.dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentcolor;
}
